// See: https://codeburst.io/throttling-and-debouncing-in-javascript-b01cad5c8edf

/**
 * Creates a debounced version for a given function in a given delay (in ms).
 * @typeParam F is the shape of the function to debounce.
 * @param func the original function
 * @param delay the delay in milliseconds (ms)
 * @returns the debounced function
 */
export function debounce(func, delay) {
  var timeout = null;

  var debounced = function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (timeout !== null) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(function () {
      return func.apply(void 0, args);
    }, delay);
  };

  return debounced;
}